import { render, staticRenderFns } from "./i-cinvoice.vue?vue&type=template&id=6fac9771&"
import script from "./i-cinvoice.vue?vue&type=script&lang=js&"
export * from "./i-cinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports